/* eslint-disable no-shadow */
import { Fragment } from 'react';
import Link from 'next/link';
import { Transition } from '@headlessui/react';
import { Button, SecondaryButtonLarge } from 'elements/Forms';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import Logo from '../../public/media/vendasta-yesware-logo.svg';

const links = [
  {
    name: 'Sales Prospecting',
    href: '/sales-prospecting/',
  },
  {
    name: 'Cold Emailing',
    href: '/cold-emailing/',
  },
  {
    name: 'Cold Calling',
    href: '/cold-calling-tips/',
  },
  {
    name: 'Follow-up Email',
    href: '/follow-up-email-template/',
  },
  {
    name: 'B2B Selling',
    href: '/definitive-guide-to-b2b-sales/',
  },
];

const BlogHeader = () => {
  const { ref, inView } = useInView({
    initialInView: true,
  });

  return (
    <>
      <div
        ref={ref}
        className="relative z-20  mx-auto hidden h-px max-w-[77rem] bg-grey-04 lg:block"
      />
      <div
        className={classNames([
          'top-0 z-10 -mt-4 hidden bg-white lg:sticky lg:block',
          !inView && 'shadow-sm',
        ])}
      >
        <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-6 py-4 lg:justify-start lg:space-x-10">
          <div
            className={classNames(
              'flex items-center transition-all',
              inView ? 'w-[172px]' : 'w-[233px]',
            )}
          >
            <Transition
              className="flex-shrink-0 text-xl font-semibold text-grey-08"
              show={inView}
              enter="transition-opacity duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              Learn more about:
            </Transition>

            <Transition
              className="absolute flex flex-shrink-0 items-center"
              show={!inView}
              enter="transition-opacity duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Link href="/" passHref>
                <a className="">
                  <span className="sr-only">Yesware</span>
                  <Logo className="w-[169px] h-[50px]" />
                </a>
              </Link>
              <div className="ml-3 flex-shrink-0 text-2xl font-semibold text-grey-08">
                <Link href="/" passHref>
                  <a>Blog</a>
                </Link>
              </div>
            </Transition>
          </div>

          <div className="hidden lg:flex lg:flex-1 lg:items-center lg:justify-between">
            <nav className="flex space-x-4 nav-1:space-x-7">
              {links.map((item) => (
                <Link key={item.name} href={item.href} passHref>
                  <a className="whitespace-nowrap text-base font-medium text-grey-08 hover:text-blue-06">
                    {item.name}
                  </a>
                </Link>
              ))}
            </nav>
            <Transition
              className="hidden items-center md:ml-12 nav-2:flex"
              show={!inView}
              enter="transition-opacity ease-in-out duration-200"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-in-out duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Button as="a" size="lg" variant="tertiary" href="/">
                Try Free Forever
              </Button>
            </Transition>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogHeader;
